module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "center"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/ReturnersWealth_revised1"
    }
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/ReturnersWealth_revised2"
    }
  }, [_vm._v("One")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/ReturnersWealth_revised3"
    }
  }, [_vm._v("Two")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/ReturnersWealth_revised4"
    }
  }, [_vm._v("Three")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/ReturnersWealth_revised5"
    }
  }, [_vm._v("Four")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/ReturnersWealth_revised6"
    }
  }, [_vm._v("Five")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/ReturnersWealth_revised7"
    }
  }, [_vm._v("Six")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/ReturnersWealth_revised8"
    }
  }, [_vm._v("Seven")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/ReturnersWealth_revised9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eight")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/ReturnersWealth_revised10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nine")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/ReturnersWealth_revised11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ten")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/ReturnersWealth_revised12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eleven")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/ReturnersWealth_revised13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twelve")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/ReturnersWealth_revised14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thirteen")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/ReturnersWealth_revised15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fourteen")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/ReturnersWealth_revised16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fifteen")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/ReturnersWealth_revised17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sixteen")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/ReturnersWealth_revised18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seventeen")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/ReturnersWealth_revised19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eighteen")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/ReturnersWealth_revised20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nineteen")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/ReturnersWealth_revised21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twenty")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/ReturnersWealth_revised22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twenty-One")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/ReturnersWealth_revised23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twenty-Two")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/ReturnersWealth_revised24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twenty-Three")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/ReturnersWealth_revised25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twenty-Four")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/ReturnersWealth_revised26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twenty-Five")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/ReturnersWealth_revised27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twenty-Six")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/ReturnersWealth_revised28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twenty-Seven")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/ReturnersWealth_revised29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twenty-Eight")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/ReturnersWealth_revised30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twenty-Nine")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/ReturnersWealth_revised31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thirty")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/ReturnersWealth_revised32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thirty-One")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/ReturnersWealth_revised33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thirty-Two")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/ReturnersWealth_revised34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thirty-Three")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/ReturnersWealth_revised35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thirty-Four")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/ReturnersWealth_revised36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thirty-Five")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/ReturnersWealth_revised37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thirty-Six")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/ReturnersWealth_revised38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thirty-Seven")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/ReturnersWealth_revised39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thirty-Eight")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/ReturnersWealth_revised40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thirty-Nine")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/ReturnersWealth_revised41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Forty")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/ReturnersWealth_revised42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Forty-One")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/ReturnersWealth_revised43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Forty-Two")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/ReturnersWealth_revised44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Forty-Three")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/ReturnersWealth_revised45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Forty-Four")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/ReturnersWealth_revised46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Forty-Five")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/ReturnersWealth_revised47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Forty-Six")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/ReturnersWealth_revised48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Forty-Seven")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/ReturnersWealth_revised49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Forty-Eight")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/ReturnersWealth_revised50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Forty-Nine")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/ReturnersWealth_revised51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fifty")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/ReturnersWealth_revised52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fifty-One")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/ReturnersWealth_revised53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fifty-Two")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/ReturnersWealth_revised54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fifty-Three")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/ReturnersWealth_revised55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fifty-Four")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/ReturnersWealth_revised56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fifty-Five")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/ReturnersWealth_revised57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fifty-Six")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/ReturnersWealth_revised58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fifty-Seven")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/ReturnersWealth_revised59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fifty-Eight")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/teaser",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Preview: "), _c('i', [_vm._v("Bloodhoney")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/ReturnersWealth_revised60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Biography of Paul Stewart and Chris Riddell")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 63
// module chunks = 0